export default __webpack_public_path__ + "static/media/screen-group.1191023f.png";